import { fakers } from "@/mocks/faker";
import type { User } from "@shared/api";
import { Tenant } from "../api";

const faker = fakers.auth;

export const MOCK_TENANT_ID = "10000000-0000-0000-0000-000000000001";
export const MOCK_TENANT_ID_2 = "10000000-0000-0000-0000-000000000002";
export const MOCK_USER_ME_ID = "10000000-0000-0000-0000-000000000010";

export const makeTenant = (partial?: Partial<Tenant>): Tenant => ({
  tenantId: faker.string.uuid(),
  complex: faker.company.name(),
  logo: faker.image.url(),
  hasAccess: true,
  ...partial,
});


export const makeMeUser = (partial?: Partial<User>): User => ({
  id: MOCK_USER_ME_ID,
  email: faker.internet.email(),
  name: faker.person.fullName(),
  role: "ADMIN",
  ...partial,
});
